import { ref, onMounted } from 'vue';
import { Capacitor } from '@capacitor/core';
import { ScreenOrientation } from '@capacitor/screen-orientation';

export function useScreenOrientation() {
  const isIPad = ref(false);
  const isIPhone = ref(false);
  const currentOrientation = ref('portrait');

  const detectDevice = () => {
    if (!Capacitor.isNativePlatform()) {
      const userAgent = navigator.userAgent.toLowerCase();
      isIPad.value = userAgent.includes('ipad');
      isIPhone.value = userAgent.includes('iphone') && !isIPad.value;
    } else {
      const screenWidth = window.screen.width;
      const screenHeight = window.screen.height;
      const maxDimension = Math.max(screenWidth, screenHeight);

      isIPad.value = maxDimension >= 1024;
      isIPhone.value = !isIPad.value && Capacitor.getPlatform() === 'ios';
    }
  };

  const configureOrientation = async () => {
    if (!Capacitor.isNativePlatform()) return;

    // iPhone : verrouiller en portrait
    // iPad : laisser libre (pas de lock)
    if (isIPhone.value) {
      try {
        await ScreenOrientation.lock({ orientation: 'portrait' });
      } catch (e) {
        console.warn('[useScreenOrientation] Failed to lock portrait:', e);
      }
    }
  };

  const listenToOrientationChanges = () => {
    const handleOrientationChange = () => {
      const orientation = window.orientation;
      switch (orientation) {
        case 0:
        case 180:
          currentOrientation.value = 'portrait';
          break;
        case 90:
        case -90:
          currentOrientation.value = 'landscape';
          break;
        default:
          currentOrientation.value = 'unknown';
      }
    };

    window.addEventListener('orientationchange', handleOrientationChange);
    window.addEventListener('resize', handleOrientationChange);

    handleOrientationChange();
  };

  onMounted(() => {
    detectDevice();
    configureOrientation();
    listenToOrientationChanges();
  });

  return {
    isIPad,
    isIPhone,
    currentOrientation,
    configureOrientation
  };
}
